import {Injectable} from '@angular/core';

@Injectable()
export class InitjsService {

  constructor() {
  }

  public initJs() {

    // We put modals out of wrapper to working properly
    $('.modal').appendTo('body');


    //    Activate bootstrap-select
    // if ($('.selectpicker').length !== 0) {
    //   (<any> $('.selectpicker')).selectpicker();
    // }

    //  Activate the tooltips
    // $('[rel="tooltip"]').tooltip();

    // removed class label and label-color from tag span and replaced with data-color
    var tagClass = $('.tagsinput').data('color');

    // $('.tagsinput').tagsinput({
    //   tagClass: ' tag-' + tagClass + ' '
    // });

    //    Activate bootstrap-select
    // $('.select').dropdown({'dropdownClass': 'dropdown-menu', 'optionClass': ''});

    $('.form-control').on('focus', function () {
      $(this).parent('.input-group').addClass('input-group-focus');
    }).on('blur', function () {
      $(this).parent('.input-group').removeClass('input-group-focus');
    });


    $('#menuresize a').click(function () {
      const href = $(this).attr('href');
      $('html,body').animate({
        'scrollTop': $($(this).attr('href')).offset().top - 100
      }, 200);
    });

    //    Activate bootstrap-select
    if ($('.select').length !== 0) {
      (<any> $(".select")).dropdown({"dropdownClass": "dropdown-menu", "optionClass": ""});
    }

  }
}




// WEBPACK FOOTER //
// ./src/app/shared/initjs.service.ts